import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import AppStorage from '@/utils/helpers';

type MobileMenuLocation = {
  location: {
    state: string | null;
    city: string | null;
    branch: string | null;
  };
  outlet: any | null;
};

const defaultInitialState: MobileMenuLocation = {
  location: { state: null, city: null, branch: null },
  outlet: null,
};

const loadMobileMenuUserLocationFromAppStorage = (): MobileMenuLocation => {
  if (typeof window === 'undefined') return defaultInitialState;
  const locationJson = AppStorage.get('mobilemenuuserlocation');
  return locationJson ? (JSON.parse(locationJson) as MobileMenuLocation) : defaultInitialState;
};

const initialState: MobileMenuLocation = loadMobileMenuUserLocationFromAppStorage();

const mobileMenuLocationSlice = createSlice({
  name: 'mobileMenuLocation',
  initialState,
  reducers: {
    updateUserState: (state, { payload }: PayloadAction<string>) => {
      state.location.state = payload;
      saveMobileMenuLocationToAppStorage({
        ...state,
        location: { ...state.location },
      });
    },
    updateUserCity: (state, { payload }: PayloadAction<string>) => {
      state.location.city = payload;
      saveMobileMenuLocationToAppStorage({
        ...state,
        location: { ...state.location },
      });
    },
    updateUserBranch: (state, { payload }: PayloadAction<string>) => {
      state.location.branch = payload;
      saveMobileMenuLocationToAppStorage({
        ...state,
        location: { ...state.location },
      });
    },
    updateUserOutlet: (state, { payload }: PayloadAction<any>) => {
      state.outlet = payload;
      saveMobileMenuLocationToAppStorage({
        ...state,
        location: { ...state.location },
      });
    },
    clearUserLocation: () => {
      AppStorage.remove('mobilemenuuserlocation');
      return defaultInitialState;
    },
  },
});

const saveMobileMenuLocationToAppStorage = (location: MobileMenuLocation) => {
  AppStorage.save('mobilemenuuserlocation', JSON.stringify(location));
};

const { actions, reducer: MobileMenuLocationReducer } = mobileMenuLocationSlice;

export const {
  updateUserState,
  updateUserCity,
  updateUserBranch,
  updateUserOutlet,
  clearUserLocation,
} = actions;
export default MobileMenuLocationReducer;
